<template>
  <div class="py-4">
    <div v-html="infoText"></div>

    <div class="mt-8">
      <strong>{{ $t('feedbacks.closeProcess_selectReason')  }}</strong>
    </div>

    <v-form ref="closeProcessForm" v-model="isValid" lazy-validation>
      <div>
        <v-select 
          v-model="selectedReason"
          :label="$t('feedbacks.closeProcess_reasonLabel')"
          :items="reasons"
          :rules="[v => !!v || $t('feedbacks.closeProcess_reasonErrorMessage')]"
          solo
          flat
          hide-details="auto"
          class="mt-2"
        ></v-select>
      </div>

      <div class="d-flex justify-end mt-4">
        <v-btn color="default" @click="$emit('cancel')">
          <v-icon class="mr-2">mdi-cancel</v-icon>
          {{ $t('cancel') }}
        </v-btn>

        <v-btn color="primary" class="ml-2" @click="submit">
          <v-icon class="mr-2">mdi-close</v-icon>
          {{ $t('close') }}
        </v-btn>
      </div>
    </v-form>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: {
    processId: {
      type: String,
      required: true
    }
  },

  data: () => ({
    selectedReason: null,
    isValid: true
  }),

  computed: {
    infoText() {
      return this.$t('feedbacks.closeProcess_info');
    },

    reasons() {
      return [
        { value: 1, text: this.$t('feedbacks.closeProcess_reason.1') },
        { value: 2, text: this.$t('feedbacks.closeProcess_reason.2') },
        { value: 3, text: this.$t('feedbacks.closeProcess_reason.3') }
      ]
    }
  },

  methods: {
    ...mapActions('feedbacks', {
      closeProcess: 'closeProcess'
    }),

    async submit() {
      this.$refs.closeProcessForm.validate();

      if (!this.isValid) {
        return;
      }

      const closeResult = await this.closeProcess({
        processId: this.processId,
        reasonId: this.selectedReason,
        reason: this.reasons.find(x => x.value === this.selectedReason).text
      });

      if (closeResult && closeResult.success) {
        this.$emit('processClosed', closeResult.result);
      }
    }
  }
}
</script>